import { c as _c } from "react/compiler-runtime";
import { useContactFields } from 'modules/contacts/hooks/use-contact-fields';
import { ContactFieldApiInterface, ContactFilterConditionInterface, ContactFilterType } from 'modules/contacts/types/contact-filter-interface';
import { getEmptyFilter } from 'modules/contacts/utils/get-empty-filter';
import { getFilter } from 'modules/contacts/utils/get-filter';
import { useCallback, useEffect, useState } from 'react';
export interface FilterWithConditionsInterface {
  conditions: ContactFilterConditionInterface[];
  setConditions: React.Dispatch<React.SetStateAction<ContactFilterConditionInterface[]>>;
  filter: ContactFilterType;
  setFilter: React.Dispatch<React.SetStateAction<ContactFilterType>>;
  filtersReady: boolean;
  clearFilter: () => void;
  filterFields?: ContactFieldApiInterface;
}
export const useFilterWithConditions = defaultFilters => {
  const $ = _c(16);
  const {
    fields
  } = useContactFields();
  let t0;
  if ($[0] !== defaultFilters) {
    t0 = defaultFilters || getEmptyFilter();
    $[0] = defaultFilters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [filter, setFilter] = useState(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [conditions, setConditions] = useState(t1);
  const [filtersReady, setFiltersReady] = useState(false);
  let t2;
  if ($[3] !== fields) {
    t2 = () => {
      setFilter(getEmptyFilter(fields));
    };
    $[3] = fields;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const clearFilter = t2;
  let t3;
  let t4;
  if ($[5] !== clearFilter || $[6] !== conditions || $[7] !== fields) {
    t3 = () => {
      if (fields) {
        clearFilter();
        if (conditions.length !== 0) {
          setFilter(prev => ({
            ...prev,
            ...getFilter(conditions, fields)
          }));
        }
        setFiltersReady(true);
      }
    };
    t4 = [fields, conditions, setFilter, clearFilter];
    $[5] = clearFilter;
    $[6] = conditions;
    $[7] = fields;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== clearFilter || $[11] !== conditions || $[12] !== fields || $[13] !== filter || $[14] !== filtersReady) {
    t5 = {
      conditions,
      setConditions,
      filter,
      setFilter,
      filtersReady,
      clearFilter,
      filterFields: fields
    };
    $[10] = clearFilter;
    $[11] = conditions;
    $[12] = fields;
    $[13] = filter;
    $[14] = filtersReady;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};